import i18n from '@/shared/i18n';
import type { AlertFrequency } from '../types/alert.types';

/** i18n key (namespace `features/assistant`) for each recurrence cadence. */
export const FREQUENCY_LABEL_KEYS: Record<AlertFrequency, string> = {
  daily: 'alerts.frequency.daily',
  weekly: 'alerts.frequency.weekly',
  biweekly: 'alerts.frequency.biweekly',
  monthly: 'alerts.frequency.monthly',
};

/**
 * Human label for an alert frequency, falling back to the raw value for an
 * unexpected cadence so the UI never renders an empty cell.
 *
 * @param frequency - The alert's recurrence cadence.
 * @returns The translated label.
 */
export function frequencyLabel(frequency: string): string {
  const key = FREQUENCY_LABEL_KEYS[frequency as AlertFrequency];
  return key ? i18n.t(key, { ns: 'features/assistant' }) : frequency;
}
